"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const SSRIcon = _ref => {
  let {
    prefix,
    viewBox,
    paths,
    colour,
    className,
    size,
    modifier,
    alt,
    ariaHidden,
    ...otherProps
  } = _ref;
  const cssStyles = (0, _classnames.default)(`${prefix}svg-icon`, className, colour && `${prefix}svg-icon--${colour}`, size && `${prefix}svg-icon--${size}`, modifier && `${prefix}svg-icon--${modifier}`);
  return paths ? _react.default.createElement("svg", _extends({
    focusable: "false",
    viewBox: viewBox
  }, otherProps, {
    className: cssStyles,
    "aria-hidden": ariaHidden
  }), paths().map((path, id) => {
    return _react.default.cloneElement(path, {
      key: id
    });
  })) : null;
};

SSRIcon.defaultProps = {
  prefix: '',
  viewBox: '0 0 24 24',
  ariaHidden: true
};
var _default = SSRIcon;
exports.default = _default;